import Layout from 'components/layout/Layout'
import { UserContext } from 'contexts/UserContext'
import Dashboard from 'pages/Dashboard/Dashboard'
import FTAcabatsDetail from 'pages/FTAcabats/FTAcabatsDetail'
import FTAcabatsList from 'pages/FTAcabats/FTAcabatsList'
import FTAcabatsRequest from 'pages/FTAcabats/FTAcabatsRequest'
import FTAcabatsRequestList from 'pages/FTAcabats/FTAcabatsRequestList'
import FTTeixiduriaRequest from 'pages/FTTeixiduria/FTTeixiduriaRequest'
import FTTeixiduriaRequestList from 'pages/FTTeixiduria/FTTeixiduriaRequestList'
import Login from 'pages/Login/Login'
import Logout from 'pages/Login/Logout'
import Profile from 'pages/Profile/Profile'
import UsersList from 'pages/Users/UsersList'
import PropTypes from 'prop-types'
import { useContext } from 'react'
import { ToastContainer } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'
import { Redirect, Route, Switch } from 'wouter'
import FTTeixiduriaLabToPDF from '../forms/ftteixiduria/FTTeixiduriaLabToPDF'
import FTTeixiduriaPosToPDF from '../forms/ftteixiduria/FTTeixiduriaPosToPDF'
import ClientsDetail from './Clients/ClientsDetail'
import ClientsList from './Clients/ClientsList'
import ClientsRequest from './Clients/ClientsRequest'
import ClientsRequestList from './Clients/ClientsRequestList'
import CheckListDetails from './Control/CheckList/CheckListDetails'
import CheckListList from './Control/CheckList/CheckListList'
import CheckListMaqDetails from './Control/CheckListMaq/CheckListMaqDetails'
import CheckListMaqList from './Control/CheckListMaq/CheckListMaqList'
import ControlVisionDetails from './Control/ControlVision/ControlVisionDetails'
import ControlVisionList from './Control/ControlVision/ControlVisionList'
import FTTeixiduriaDetail from './FTTeixiduria/FTTeixiduriaDetail'
import FTTeixiduriaList from './FTTeixiduria/FTTeixiduriaList'
import FTTeixiduriaProtoDetail from './FTTeixiduria/ProtoDetail'
import Inventory from './Inventory/Inventory'
import InventoryDetails from './Inventory/InventoryDetails'
import MaintenanceDetails from './Maintenance/MaintenanceDetails'
import MaintenanceList from './Maintenance/MaintenanceList'
import MaintOthersDetails from './Maintenance/MaintOthersDetails'
import MaintOthersList from './Maintenance/MaintOthersList'
import NCDetails from './NC/NCDetails'
import NCList from './NC/NCList'
import PrevenOthersDetails from './PreventiveWeaving/PrevenOthersDetails'
import PrevenOthersList from './PreventiveWeaving/PrevenOthersList'
import PrevenTeixDetails from './PreventiveWeaving/PrevenTeixDetails'
import PrevenTeixList from './PreventiveWeaving/PrevenTeixList'
import ForecastTrainingDetails from './RRHH/ForecastTrainings/ForecastTrainingDetails'
import ForecastTrainingList from './RRHH/ForecastTrainings/ForecastTrainingList'
import JobDetails from './RRHH/Jobs/JobDetails'
import JobList from './RRHH/Jobs/JobList'
import MapaEmpresesList from './RRHH/MapaEmpreses/MapaEmpresesList'
import SuggestionDetails from './RRHH/Suggestions/SuggestionDetails'
import SuggestionList from './RRHH/Suggestions/SuggestionList'
import TrainingPlanDetails from './RRHH/TrainingPlans/TrainingPlanDetails'
import TrainingPlanList from './RRHH/TrainingPlans/TrainingPlanList'
import TreballadorsDetails from './RRHH/Treballadors/TreballadorsDetails'
import TreballadorsList from './RRHH/Treballadors/TreballadorsList'
import VersatilityDetails from './RRHH/Versatility/VersatilityDetails'
import VersatilityList from './RRHH/Versatility/VersatilityList'
import UserDetail from './Users/UserDetail'

/* -------------------------------------------------------------------------- */
/*                         Control de acceso (rol + permisos)                  */
/* -------------------------------------------------------------------------- */

// Oficina: solo con permiso | Operador: sin acceso (rol ausente)
const ACCESS_USERS = { Office: ['UsersFullPermission'] }
const ACCESS_RRHH = { Office: ['HumanResourcesFullPermission'] }

// Oficina: acceso libre | Operador: solo con permiso
const ACCESS_OFFICE = { Office: null }
const ACCESS_PREVEN_TEIX = {
  Office: null,
  Operator: ['CanAccessWeavingPreventive']
}
const ACCESS_PREVEN_ACABATS = {
  Office: null,
  Operator: ['CanAccessFinishedPreventive']
}

// Un usuario está autenticado si dispone de token
const isAuthenticated = (user) => Boolean(user?.Token)

// Indica si el usuario cumple las reglas de acceso de una ruta
const hasAccess = (user, access) => {
  if (!access) return true

  const roleName = user?.Role?.Name
  if (!roleName || !(roleName in access)) return false

  const requiredPermissions = access[roleName]
  if (!requiredPermissions || requiredPermissions.length === 0) return true

  return requiredPermissions.every((permission) =>
    user?.Permissions?.includes(permission)
  )
}

// Ruta privada: exige estar autenticado y, opcionalmente, cumplir 'access'
const PrivateRoute = ({ access = null, ...routeProps }) => {
  const { user } = useContext(UserContext)

  if (!isAuthenticated(user)) return <Redirect to="/login" />
  if (!hasAccess(user, access)) return <Redirect to="/" />

  return (
    <Layout>
      <Route {...routeProps} />
    </Layout>
  )
}

// Ruta pública: solo para usuarios sin sesión (login), Si ya hay sesión, redirige al dashboard
const LoginRoute = (routeProps) => {
  const { user } = useContext(UserContext)
  return isAuthenticated(user) ? <Redirect to="/" /> : <Route {...routeProps} />
}

export default function App() {
  // TODO: reactivar el contador de mantenimientos pendientes (MTContext) cuando se necesite. Antes se hacía así:
  // const { setMT } = useContext(MTContext)
  // const [mtList, mtListAction] = useFetch()

  // useEffect(() => {
  //   const mtListAPIParams = {
  //   url: `maintenancepart`,
  //   method: 'GET',
  //   messageKo: 'Error al recuperar dades del ECAP'
  // }
  // mtListAction(mtListAPIParams)
  // }, []);

  // useEffect(() => {
  //   if (mtList.data) {
  //     setMT(mtList.data.filter((mt) => mt.CorrectiveDate === null).length)
  //   }
  // }, [mtList.data])

  return (
    <>
      <Switch>
        {/* ###################################################### */}
        {/* #################### AUTENTICACIÓN #################### */}
        {/* ###################################################### */}
        <LoginRoute path="/login" component={Login} />
        <PrivateRoute path="/logout" component={Logout} />

        {/* ################################################### */}
        {/* #################### GENERALES #################### */}
        {/* ################################################### */}
        <PrivateRoute path="/" component={Dashboard} />
        <PrivateRoute path="/perfil" component={Profile} />

        {/* #################################################### */}
        {/* #################### FT ACABATS #################### */}
        {/* #################################################### */}
        <PrivateRoute path="/ft-acabats" component={FTAcabatsList} />
        <PrivateRoute path="/ft-acabats/:id" component={FTAcabatsDetail} />

        {/* SOL·LICITUD */}
        <PrivateRoute
          path="/ft-acabats/requests/:id"
          component={FTAcabatsRequestList}
        />
        <PrivateRoute path="/ft-acabats/request-check/:articleCode/:idRequest">
          {(params) => <FTAcabatsRequest type="Check" params={params} />}
        </PrivateRoute>
        <PrivateRoute path="/ft-acabats/request-:type/:articleCode/:idRequest?">
          {(params) => <FTAcabatsRequest params={params} />}
        </PrivateRoute>

        {/* PREVENTIU */}
        <PrivateRoute
          access={ACCESS_PREVEN_ACABATS}
          path="/prevenacabats"
          component={PrevenOthersList}
        />
        <PrivateRoute
          access={ACCESS_PREVEN_ACABATS}
          path="/prevenacabats/:id"
          component={PrevenOthersDetails}
        />

        {/* MANTENIMENT */}
        <PrivateRoute path="/mantothers" component={MaintOthersList} />
        <PrivateRoute path="/mantothers/:id" component={MaintOthersDetails} />

        {/* ####################################################### */}
        {/* #################### FT TEIXIDURIA #################### */}
        {/* ####################################################### */}
        <PrivateRoute path="/ft-teixiduria" component={FTTeixiduriaList} />
        <PrivateRoute
          path="/ft-teixiduria/:id"
          component={FTTeixiduriaDetail}
        />
        <PrivateRoute path="/laboratori" component={FTTeixiduriaLabToPDF} />
        <PrivateRoute path="/posadamarxa" component={FTTeixiduriaPosToPDF} />

        {/* SOL·LICITUD */}
        <PrivateRoute
          path="/ft-teixiduria/requests/:id"
          component={FTTeixiduriaRequestList}
        />
        <PrivateRoute path="/ft-teixiduria/request-check/:articleId/:idRequest">
          {(params) => <FTTeixiduriaRequest type="Check" params={params} />}
        </PrivateRoute>
        <PrivateRoute path="/ft-teixiduria/request-:type/:id/:idRequest?">
          {(params) => <FTTeixiduriaRequest params={params} />}
        </PrivateRoute>

        {/* PROTO */}
        <PrivateRoute
          path="/ft-proto-teixiduria"
          component={FTTeixiduriaProtoDetail}
        />

        {/* PREVENTIU */}
        <PrivateRoute
          access={ACCESS_PREVEN_TEIX}
          path="/preventeix"
          component={PrevenTeixList}
        />
        <PrivateRoute
          access={ACCESS_PREVEN_TEIX}
          path="/preventeix/:id"
          component={PrevenTeixDetails}
        />

        {/* MANTENIMENT */}
        <PrivateRoute path="/mantteix" component={MaintenanceList} />
        <PrivateRoute path="/mantteix/:id" component={MaintenanceDetails} />

        {/* ######################################################### */}
        {/* #################### NO CONFORMITATS #################### */}
        {/* ######################################################### */}
        <PrivateRoute path="/no-conformitats" component={NCList} />
        <PrivateRoute path="/no-conformitats/:id" component={NCDetails} />

        {/* ############################################## */}
        {/* #################### RRHH #################### */}
        {/* ############################################## */}
        {/* SUGGERIMENT */}
        <PrivateRoute path="/sugerencia" component={SuggestionList} />
        <PrivateRoute path="/sugerencia/:id" component={SuggestionDetails} />

        {/* PLA FORMACIÓ */}
        <PrivateRoute
          access={ACCESS_RRHH}
          path="/pla-formacio"
          component={ForecastTrainingList}
        />
        <PrivateRoute
          access={ACCESS_RRHH}
          path="/pla-formacio/:id"
          component={ForecastTrainingDetails}
        />

        {/* SEGUIMENT (FORMACIÓ) */}
        <PrivateRoute
          access={ACCESS_RRHH}
          path="/seguiment-formacio"
          component={TrainingPlanList}
        />
        <PrivateRoute
          access={ACCESS_RRHH}
          path="/seguiment-formacio/:id"
          component={TrainingPlanDetails}
        />

        {/* LLOC TREBALL */}
        <PrivateRoute
          access={ACCESS_RRHH}
          path="/lloc-treball"
          component={JobList}
        />
        <PrivateRoute
          access={ACCESS_RRHH}
          path="/lloc-treball/:id"
          component={JobDetails}
        />

        {/* TREBALLADORS */}
        <PrivateRoute
          access={ACCESS_RRHH}
          path="/treballadors"
          component={TreballadorsList}
        />
        <PrivateRoute
          access={ACCESS_RRHH}
          path="/treballadors/:id"
          component={TreballadorsDetails}
        />

        {/* POLIVALÈNCIA */}
        <PrivateRoute
          access={ACCESS_RRHH}
          path="/polivalencies"
          component={VersatilityList}
        />
        <PrivateRoute
          access={ACCESS_RRHH}
          path="/polivalencies/:id"
          component={VersatilityDetails}
        />

        {/* TODO: rutas desactivadas
        <PrivateRoute
          path="/checklist-formacio"
          component={CheckListTrainingPlanList}
        />
        <PrivateRoute
          path="/checklist-formacio/:id"
          component={CheckListTrainingPlanDetails}
        />
        <PrivateRoute
          path="/mapa-empreses"
          component={MapaEmpresesList}
        />
        <PrivateRoute
          path="/mapa-empreses/:id"
          component={MapaEmpresesDetails}
        />
        <PrivateRoute
          path="/enquesta-satisfaccio"
          component={SatisfactionSurveyList}
        />
        <PrivateRoute
          path="/enquesta-satisfaccio/:id"
          component={SatisfactionSurveyDetails}
        />
        */}

        {/* ################################################# */}
        {/* #################### CONTROL #################### */}
        {/* ################################################# */}
        {/* CONTROL VISIÓ */}
        <PrivateRoute path="/visioncontrol" component={ControlVisionList} />
        <PrivateRoute
          path="/visioncontrol/:id"
          component={ControlVisionDetails}
        />

        {/* CHECKLIST (RAM) */}
        <PrivateRoute path="/checklist" component={CheckListList} />
        <PrivateRoute path="/checklist/:id" component={CheckListDetails} />

        {/* CHECKLIST (MAQ) */}
        <PrivateRoute path="/checklistmaq" component={CheckListMaqList} />
        <PrivateRoute
          path="/checklistmaq/:id"
          component={CheckListMaqDetails}
        />

        {/* ################################################# */}
        {/* #################### USUARIS #################### */}
        {/* ################################################# */}
        <PrivateRoute
          access={ACCESS_USERS}
          path="/usuaris"
          component={UsersList}
        />
        <PrivateRoute
          access={ACCESS_USERS}
          path="/usuari/:id"
          component={UserDetail}
        />

        {/* ################################################## */}
        {/* ##################### CLIENTS #################### */}
        {/* ################################################## */}
        <PrivateRoute path="/clients" component={ClientsList} />
        <PrivateRoute path="/client/:id" component={ClientsDetail} />
        <PrivateRoute
          path="/client/requests/:id"
          component={ClientsRequestList}
        />
        <PrivateRoute path="/client/request-check/:id/:idRequest">
          {(params) => <ClientsRequest type="Check" params={params} />}
        </PrivateRoute>
        <PrivateRoute path="/client/request-:type/:id/:idRequest?">
          {(params) => <ClientsRequest params={params} />}
        </PrivateRoute>

        {/* ################################################### */}
        {/* #################### INVENTARI #################### */}
        {/* ################################################### */}
        <PrivateRoute
          access={ACCESS_OFFICE}
          path="/inventari"
          component={Inventory}
        />
        <PrivateRoute
          access={ACCESS_OFFICE}
          path="/inventari/:id"
          component={InventoryDetails}
        />
      </Switch>

      <ToastContainer />
    </>
  )
}

PrivateRoute.propTypes = {
  isLoggedIn: PropTypes.bool,
  access: PropTypes.object
}

LoginRoute.propTypes = {
  isLoggedIn: PropTypes.bool
}
